import actionTypes from '../constants/action-types';

const detachGlobal = (globalElement) => ({
  type: actionTypes.DETACH_GLOBAL,
  payload: {
    globalElement,
  },
});

export default detachGlobal;
